// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1bRKs","col":"CardReaderDesc_col__3S0EZ","label":"CardReaderDesc_label__3Ex1P"};